"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _reactAnimateHeight = _interopRequireDefault(require("react-animate-height"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./ExpansionPanel.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * The ExpansionPanel  is a lightweight container that may either stand alone or be connected to a larger surface, such as a card or a carousel
 *
 * The header title give the user a high level overview of the content allowing the user to decide which sections to read.
 *
 * When a `ref` prop is provided, it will be forwarded to the root element. Any
 * other properties supplied will be provided to the root element (ie, the `as`
 * prop value). This includes all appropriate HTML attributes or aria tags.
 */
const ExpansionPanel = /*#__PURE__*/React.forwardRef(({
  title,
  content,
  interactive = true,
  expandExternally,
  setExpandExternally,
  gutter = 'none',
  variant = 'interactive1',
  ...otherProps
}, ref) => {
  const [expand, setExpand] = React.useState(false);
  const controlled = setExpandExternally && expandExternally !== undefined;

  const onClick = () => {
    if (setExpandExternally) {
      setExpandExternally();
    } else setExpand(!expand);
  };

  const setHeight = () => {
    if (controlled) return expandExternally ? 'auto' : 0;
    return expand ? 'auto' : 0;
  };

  return (0, _pragma.createFelaElement)(_.View, {
    margin: gutter,
    flex: true
  }, (0, _pragma.createFelaElement)(_.Card, _extends({
    ref: ref,
    width: "full",
    "aria-label": "expansion-panel",
    interactive: interactive,
    variant: variant,
    onClick: onClick
  }, otherProps), (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    flexDirection: "column"
  }, (0, _pragma.createFelaElement)(_.View, {
    padding: "small",
    justifyContent: "space-between"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "bodyBold",
    color: "text.1"
  }, title), (0, _pragma.createFelaElement)(_.View, {
    "aria-label": "expansion-panel-chevron",
    margin: ['none', 'xxsmall', 'none', 'xsmall']
  }, (0, _pragma.createFelaElement)(_.ChevronDownIcon, {
    css: css.icon,
    cssProps: {
      expand: controlled ? expandExternally : expand
    },
    size: "large"
  }))), (0, _pragma.createFelaElement)(_reactAnimateHeight.default, {
    height: setHeight()
  }, (0, _pragma.createFelaElement)(_.View, {
    padding: ['none', 'small', 'medium', 'medium']
  }, content)))));
});
ExpansionPanel.displayName = 'ExpansionPanel';
var _default = ExpansionPanel;
exports.default = _default;
//# sourceMappingURL=ExpansionPanel.js.map